import { render, staticRenderFns } from "./ViewDispatchesToInvoice.vue?vue&type=template&id=227ce5e8&scoped=true&"
import script from "./ViewDispatchesToInvoice.vue?vue&type=script&lang=js&"
export * from "./ViewDispatchesToInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ce5e8",
  null
  
)

export default component.exports